import { UI, HStack, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import { FlatList } from 'native-base';
import React from 'react';

import { IBlockedAssetNormalized } from '../../../../../../store/customerDetail/types';
import { LoadingTable } from '../../../shared/LoadingTable';
import { EmptyList } from '../EmptyList';
import { ErrorListing } from '../ErrorListing';

import { emptyListProps, tableHead, tabletWidthCols } from './constants';

import { BlockedTypes } from '.';

interface ItemProps {
  item: IBlockedAssetNormalized;
}

export const ItemValueTablet: React.FC<{ value: string; label: string; width: number }> = ({
  value,
  label,
  width,
}) => {
  return (
    <VStack space="stack.nano" px="inline.nano" w={`${width}%`}>
      <UI.Text variant="semibold">{label}</UI.Text>
      <UI.Text noOfLines={10}>{value}</UI.Text>
    </VStack>
  );
};

export const ItemTablet: React.FC<ItemProps> = ({ item }) => {
  return (
    <UI.Shadow level={1} p="inset.xs" my="stack.nano" borderRadius="sm">
      <HStack alignItems="center" justifyContent="space-between">
        <ItemValueTablet
          label={tableHead.description}
          value={item.description}
          width={tabletWidthCols.description}
        />
        <ItemValueTablet
          label={tableHead.value}
          value={Utils.Mask.Money(item.value)}
          width={tabletWidthCols.value}
        />
      </HStack>
    </UI.Shadow>
  );
};

export const BlockedTablet: React.FC<BlockedTypes.Props> = ({
  blockedAssets,
  error,
  isLoading,
  onRefresh,
}) => {
  const renderTable = () => {
    if (error) {
      return <ErrorListing handleReload={onRefresh} />;
    }
    if (blockedAssets.length === 0 && !isLoading) {
      return <EmptyList {...emptyListProps} />;
    }
    return (
      <UI.Table testId="table-customers-ties" isLoading={false} cols={3} rows={5}>
        {isLoading ? (
          <LoadingTable columnsWidths={tabletWidthCols} />
        ) : (
          <FlatList
            windowSize={20}
            maxToRenderPerBatch={20}
            updateCellsBatchingPeriod={5}
            data={blockedAssets}
            showsVerticalScrollIndicator={false}
            onEndReachedThreshold={1.5}
            renderItem={({ item }) => <ItemTablet item={item} />}
          />
        )}
      </UI.Table>
    );
  };

  return (
    <UI.Shadow
      level={1}
      borderRadius="sm"
      my="inset.sm"
      paddingX="inline.xxxs"
      paddingY="inline.xxs"
      pb={0}>
      {renderTable()}
    </UI.Shadow>
  );
};
